var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({attrs:{"value":_vm.value,"outlined":"","rules":_vm.rules,"background-color":_vm.color,"persistent-placeholder":"","name":Math.random(),"autocomplete":"new-password"}},'v-text-field',_vm.$attrs,false),_vm.inputListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }